// extracted by mini-css-extract-plugin
export default {"readContainer":"helpers__readContainer--IcWSH1n","text":"helpers__text--sMMhT_O","divider":"helpers__divider--gE93eSJ","flexContainer":"helpers__flexContainer--bU6UObm"};